import { call, put, takeEvery } from "redux-saga/effects";
import CryptoJS from 'crypto-js';
// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SSO_LOGIN_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";
//Include Both Helper File with needed methods
import { postDataAPI } from "../../../helpers/phpbackend_helper";

import { POST_LOGIN_DATA } from "../../../helpers/data_helper";
import { saveLoggedinUser, clearAllCookies, setLocalStorageData, decodefn } from "../../../helpers/api_helper";
let md5 = require("md5");



const RAW_KEY = 'login-attempt'; // obfuscated key
const STORAGE_KEY = CryptoJS.MD5(RAW_KEY).toString(); // obfuscated but fixed

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(postDataAPI, {
      uname: user.email,
      //pwd: md5(user.password),
      pwd: user.password,
      op: POST_LOGIN_DATA.op,
      serviceName: POST_LOGIN_DATA.serviceName,
      recaptcha_token: user.recaptcha_token,
    });

    if (response.status === "ok") {
      //let res_data = JSON.parse(decryptFromServer(response.data));
      //let res_data = yield call(decryptFromServer, response.data);
      let res_data = response.data;
      
      //let res_data = JSON.parse(decrypted);
      const auth_token = res_data.user_details.user_id || "";
      let userId = auth_token;
      if (auth_token) {
        userId = parseInt(auth_token.substring(0, 5));
      }
      res_data['user_id'] = userId;
      res_data['user_details']['user_id'] = userId;
      saveLoggedinUser(JSON.stringify(res_data));
      localStorage.removeItem(STORAGE_KEY); // clear attempts
      setLocalStorageData('AuthToken', auth_token || "");
      const finalResponse = {
        ...response,
        data: res_data
      };
      yield put(loginSuccess(finalResponse));
      history.push("/playground");
    } else {
      //handleLoginAttempt()
    yield put(apiError(response));
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser() {
  try {
    const response = yield call(postDataAPI, {
      withoutRedirect: 0,
      op: 'logout',
      serviceName: 'user_data',
    });
    //console.log(response,"Response");
    if (response.status === "ok") {
      console.log("Logout Success!");
      
    }

    clearAllCookies();
    saveLoggedinUser("");
    localStorage.removeItem('app_data');
    yield put(logoutUserSuccess(LOGOUT_USER, true));
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* ssoLoginUser({ payload: { token, history } }) {
  try {
    const response = yield call(postDataAPI, {
      serviceName: "user_sso",
      op: "ssologin-result",
      token: token,
    });
    saveLoggedinUser(JSON.stringify(response.data));
    if (response.status === "ok") {
      yield put(loginSuccess(response));
      history.push("/playground");
    } else {
      yield put(apiError(response));
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(SSO_LOGIN_USER, ssoLoginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
